"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSpaceBlocks = fixSpaceBlocks;
const tex_syntax_1 = require("./tex-syntax");
function fixSpaceBlocks(tex) {
    return tex.replace(new RegExp(`\\\\space(${(0, tex_syntax_1.block)(0)})`, "g"), (wholeString, innerBlock) => {
        return " " + innerBlock.replace(new RegExp(`[{}]`, "g"), "");
    });
}
